import React from 'react';
import { Link } from 'react-router-dom';
import propTypes from 'prop-types';
import { Breadcrumb } from 'antd';

const CustomBreadcrumb = ({ breadcrumb = [] }) => (
  <Breadcrumb>
    <h1>
      {breadcrumb.map(({ url, name }) => (
        <Link key={url} to={url} name={name}>
          {name}
        </Link>
      ))}
    </h1>
  </Breadcrumb>
);
CustomBreadcrumb.propTypes = {
  breadcrumb: propTypes.array,
};
export default CustomBreadcrumb;
